import type { SearchControllerSearchResponse } from '@carvia/ros-client-types';
import { httpClient } from './http-client';

export type GlobalSearchResponse = SearchControllerSearchResponse;

class SearchService {
  async search(q: string): Promise<GlobalSearchResponse> {
    const res = await httpClient.get<GlobalSearchResponse>('/search', { params: { q } });
    return res.data;
  }
}

export const searchService = new SearchService();
